import { Object3D } from 'three';

export function hideTargetObjects(rootObject: Object3D, objectsToHide: string[]) {  
  if(rootObject.children){
    rootObject.children
      .filter((obj) => {        
        return obj.isObject3D && objectsToHide.includes(obj.name.toLowerCase())}
        )
      .forEach((o) => {          
        rootObject.remove(o)
      })    
    rootObject.children.forEach((obj) => hideTargetObjects(obj, objectsToHide))    
  }
}
